/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q6Inputs */

const en_formatter_faq_q6 = /** @type {(inputs: Formatter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why did my large ID number change?`)
};

const ko_formatter_faq_q6 = /** @type {(inputs: Formatter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`큰 ID 숫자가 왜 바뀌었나요?`)
};

const ja_formatter_faq_q6 = /** @type {(inputs: Formatter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きな ID の数値がなぜ変わったのですか`)
};

/**
* | output |
* | --- |
* | "Why did my large ID number change?" |
*
* @param {Formatter_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q6 = /** @type {((inputs?: Formatter_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q6(inputs)
	if (locale === "ko") return ko_formatter_faq_q6(inputs)
	return ja_formatter_faq_q6(inputs)
});